import React, { useState } from 'react';
import { Image, Space, Button } from 'antd';
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
const ImageUploadPreview = ({ file, onDelete, viewButton = false }) => {
    const [previewVisible, setPreviewVisible] = useState(false);

    const src = file instanceof File ? URL.createObjectURL(file) : file?.url || file;

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <Image
                src={src}
                width={100}
                height={100}
                style={{ objectFit: 'cover', borderRadius: 8 }}
                onClick={(e) => {
                    e.stopPropagation();
                    setPreviewVisible(true);
                }}
                preview={{
                    visible: previewVisible,
                    onVisibleChange: (vis) => setPreviewVisible(vis),
                }}
            />

            {/* Action buttons */}
            <Space
                onClick={(e) => e.stopPropagation()}
                style={{
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    background: 'rgba(0,0,0,0.4)',
                    borderRadius: 4,
                    padding: 2,
                }}
            >
                {viewButton && (
                    <Button
                        type="text"
                        icon={<EyeOutlined style={{ color: '#fff' }} />}
                        onClick={(e) => {
                            e.stopPropagation();
                            setPreviewVisible(true);
                        }}
                    />
                )}

                <Button
                    type="text"
                    icon={<DeleteOutlined style={{ color: '#fff' }} />}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete();
                    }}
                />
            </Space>
        </div>
    );
};

export default ImageUploadPreview;
